import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { deleteDriver, deleteDrivers } from '../../services/DriversService';
import { Driver, DeleteDriverRequest, DeleteDriversRequest } from '../../types/Drivers';

type Result = UseMutationResult<Driver, Error, DeleteDriverRequest>;

function useDeleteDriver(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteDriver, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['drivers'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

type MultiDriverResult = UseMutationResult<Driver[], Error, DeleteDriversRequest>;

export function useDeleteDrivers(successCb: () => void, failureCb: (error: string) => void): MultiDriverResult {
  const queryClient = useQueryClient();

  return useMutation(deleteDrivers, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['drivers'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteDriver;
